import React, { FC } from 'react';
import { useEffect } from 'react';
import { FORM_CHOICE_CHECKBOX_COMPONENT_TYPES } from './types';
import FormContainer, { PreviousPage } from '../Shared/FormContainer/FormContainer';
import { FormLabel, FormChoiceCheckboxWrapper, FormChoiceCheckboxButtons, FormChoiceCheckboxButton, ChoiceContainer, Accessibility } from './styled';
import useKeyPress from '../../hooks/useKeyPress';
import { ALPHABETS } from '../../utils';
import { useForm } from 'react-hook-form';
import { RequireAtLeastOne } from '../../types';

interface FormChoiceCheckboxProps {
  onSubmit: (data: any) => void;
  type?: keyof typeof FORM_CHOICE_CHECKBOX_COMPONENT_TYPES;
  formOptions: ReturnType<typeof useForm>;
  title?: string;
  loading?: boolean;
  previousPage?: PreviousPage;
  componentItems?: { title: string; options: { option: string; value: string }[]; registerAs: string };
  defaultValue?: string[];
}

const FormChoiceCheckbox: FC<RequireAtLeastOne<FormChoiceCheckboxProps, 'type' | 'componentItems'>> = ({ type, formOptions, title, loading, previousPage, componentItems, onSubmit, defaultValue }) => {
  const { title: defaultTitle, options, registerAs } = componentItems || FORM_CHOICE_CHECKBOX_COMPONENT_TYPES[type!];
  const { register, setValue, getValues, handleSubmit } = formOptions;

  const keys = useKeyPress(ALPHABETS.slice(0, options.length));

  useEffect(() => {
    if (keys) {
      const index = ALPHABETS.findIndex(alphabet => keys[alphabet]);
      const hasValues = !!getValues()[`choice_${registerAs}`]?.[index];
      if (index !== -1) {
        setValue(`choice_${registerAs}.${index}`, hasValues ? false : options[index].value);
      }
    }
  }, [keys]);

  const submitHandler = (data: { [key: string]: (string | boolean)[] }) => {
    // will comment this temporarily, as we want to allow user to submit empty array
    // if (!Object.values(data || {})?.[0]?.filter(Boolean)?.length) {
    //   return;
    // }
    onSubmit(data);
  };

  return (
    <FormChoiceCheckboxWrapper>
      <FormContainer title={title || defaultTitle} loadingData={loading} previousPage={previousPage} onSubmit={handleSubmit(submitHandler)}>
        <FormChoiceCheckboxButtons disabled={loading}>
          {options.map((option, index) => (
            <ChoiceContainer key={index}>
              <FormLabel>
                <input
                  type="checkbox"
                  {...register(`choice_${registerAs}.${index}`, {
                    validate: () => loading
                  })}
                  value={option.value}
                  defaultChecked={defaultValue?.includes(option.value)}
                />
                <FormChoiceCheckboxButton pressed={keys[ALPHABETS[index]]} disabled={loading}>
                  <span>{option.option}</span>
                </FormChoiceCheckboxButton>
                <Accessibility>
                  or Press <span>{ALPHABETS[index]}</span>
                </Accessibility>
              </FormLabel>
            </ChoiceContainer>
          ))}
        </FormChoiceCheckboxButtons>
      </FormContainer>
    </FormChoiceCheckboxWrapper>
  );
};

export default FormChoiceCheckbox;
